import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchComparatorData } from '../../../api/comparator';
import { IComparatorProps } from '../../../apps/comparator';

export type IFetchComparatorDataAsync = Omit<IComparatorProps, 'addToCart' | 'analytics'>;

export const fetchComparatorDataAsync = createAsyncThunk(
  'comparator/getData',
  ({ ...props }: IFetchComparatorDataAsync) => {
    const response = fetchComparatorData({ ...props });
    return response;
  },
);
